import React from "react";
import DisplayComponent from "./DisplayComponent";
import { WidgetId, useDisplaySettings } from "./DisplaySettingsProvider";

const Text = ({ id }: { id: WidgetId }) => {
  const { state } = useDisplaySettings();

  return (
    <DisplayComponent id={id} style={{ top: 630, left: 0 }}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style: React.CSSProperties = {
          fontSize: sizeMultiplier * 32,
          width: sizeMultiplier * 600,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          whiteSpace: "nowrap",
        };

        return <div style={style}>{state.tx.tx}</div>;
      }}
    </DisplayComponent>
  );
};

export default Text;
